<template>
  <div class="repayment">
    <div class="repayment_pending" v-if="isPending">
      <div class="repayment_pending_text">Pending</div>
      <div class="repayment_pending_tips">
        You will shortly receive a
        <span>{{ countryInfo?.currencyCode || 'XOF' }} {{ formattedAmount }}</span> bill prompt,
        please authorise the payment
      </div>
      <div class="repayment_pending_img_box">
        <img
          class="repayment_pending_img"
          src="@/assets/prokash/pending.gif"
          alt=""
        />
      </div>
      <div class="repayment_pending_desc">
        <div>Once approved,</div>
        <div>you'll receive a notification for completion,</div>
        <div>and your savings account will open</div>
      </div>
      <div class="repayment_pending_over">
        <span>*</span>If you don't see the transfer within one business day of
        sending the payment,please reach out to our support team
      </div>
    </div>

    <div class="repayment_over" v-if="!isPending && isOver">
      <div class="repayment_over_img_box">
        <img
          class="repayment_over_img"
          src="@/assets/prokash/success.png"
          alt=""
        />
      </div>
      <div class="repayment_over_text">{{ $t('text_successful_repayment') }}</div>
      <div @click="back" class="repayment_over_btn">{{ $t('text_close') }}</div>
    </div>

    <!--    付款账号-->
    <van-popup get-container="body" v-model="paymentAccountShow" :close-on-click-overlay="false">
      <div class="moblie_pay_payment_account_popup">
        <div class="moblie_pay_payment_account_popup_main">
          <div class="moblie_pay_payment_account_popup_main_title">
            {{ paymentAccountPopupTitle }}
          </div>
          <div class="moblie_pay_payment_account_popup_main_desc" v-if="!isCustomBlueTheme">
            Enter your actual payment account to complete the payment.
          </div>
          <div class="moblie_pay_payment_account_popup_main_wait_amount">
            Amount obligated:<span>{{ countryInfo?.currencyCode || 'XOF' }}</span>
            <span
              class="moblie_pay_payment_account_popup_main_wait_amount_num"
              >{{ formattedAmount }}</span
            >
          </div>
          <div class="moblie_pay_container_step_account" v-if="operatorOptions.length">
            <van-field
                readonly
                clickable
                name="operator"
                :value="operator"
                placeholder="Please select the operator"
                class="moblie_pay_container_step_account_input_box moblie_pay_container_step_account_select_box"
                @click="realFocus('operator')"
                :rules="[{ required: true }]"
            >
              <template #right-icon>
                <img
                    class="moblie_pay_container_step_account_input_box_right_img"
                    src="@/assets/prokash/right@2x.png"
                    alt=""
                />
              </template>
            </van-field>
          </div>
          <div class="moblie_pay_container_step_account">
            <div class="moblie_pay_container_step_account_input_box">
              <div class="moblie_pay_container_step_233">+{{ countryInfo?.phoneCode || '229' }}</div>
              <input
                v-model="paymentAccount"
                class="moblie_pay_container_step_account_input"
                type="text"
                :maxlength="phoneMaxLength"
                :placeholder="paymentAccountPopupInputPlaceholder"
              />
            </div>
          </div>
          <div class="moblie_pay_container_step_tips" v-if="!isCustomBlueTheme">
            <span>*</span>{{ $t('text_please_enter_your_actual_payment_account') }}
          </div>
          <div class="moblie_pay_container_step_pay_account">
            <img
              v-if="showPaymentAccountPopupWarningIcon"
              class="moblie_pay_container_step_pay_account_img"
              src="@/assets/cardPay_NG/danger.png"
              alt=""
            />
            <template v-if="paymentAccountPopupWarning">{{ paymentAccountPopupWarning }}</template>
            <template v-else>
              Please complete your payment account with precision, filling the
              error may lead to the loss of funds transferred.
            </template>
          </div>
          <div
            @click="paymentAccountSubmit"
            class="moblie_pay_container_step_account_submit"
          >
            <div class="moblie_pay_container_step_account_submit_text">
              {{ paymentAccountPopupSubmitText }}
            </div>
            <img
              class="moblie_pay_container_step_account_submit_img"
              src="@/assets/cardPay_GH/submit.png"
              alt=""
            />
          </div>
          <div style="height: 20px"></div>
        </div>
      </div>
    </van-popup>
    <van-popup get-container="body" round v-model="operatorPopup" position="bottom">
      <van-picker
          :confirm-button-text="$t('text_confirm')"
          :cancel-button-text="$t('text_return')"
          show-toolbar
          value-key="text"
          :columns="operatorOptions"
          :default-index="operatorDefaultIndex"
          @confirm="operatorChange"
          @cancel="operatorPopup = false"
      />
    </van-popup>
  </div>
</template>

<script>
import paymentAccountPopupCopy from '@/mixins/paymentAccountPopupCopy';
import {
  applyCountryCurrencyCode,
  checkPaymentPhone,
  findMnoInfoByBankCode,
  formatDecimalByPlaces,
  getPaymentPhoneMaxLength,
  zeroFillPaymentPhone,
} from "@/utils/countryAdapter";
import { setLanguageByCountry } from "@/utils/languageAdapter";

export default {
  name: "repayment",
  mixins: [paymentAccountPopupCopy],
  props: {
    pageData: Object,
  },
  watch: {
    pageData(val) {
      this.repaymentData = val;
      this.updateCode();
      this.setLanguageBasedOnCountry(this.countryInfo?.enName);
      this.initOperatorList();
    },
  },
  data() {
    return {
      repaymentData: {},

      hr: undefined,
      min: undefined,
      sec: undefined,

      paymentAccount: "",
      paymentAccountNumber: "",
      paymentAccountShow: false,

      isPending: false,
      isOver: false,

      amount: undefined,

      operator: "",
      operatorValue: "",
      operatorPopup: false,
      operatorDefaultIndex: 0,
      operatorOptions: [],
    };
  },
  components: {},
  computed: {
    //国家信息
    countryInfo() {
      return this.repaymentData?.configData?.countryInfoVO;
    },
    phoneMaxLength() {
      return getPaymentPhoneMaxLength(this.countryInfo);
    },
    currentBankInfo() {
      const bankCode =
        this.operatorValue || this.repaymentData?.paymentData?.bankCode;
      const matchedOperator = this.operatorOptions.find(
        (v) => String(v.value) === String(bankCode)
      );
      if (matchedOperator?.decimalPlaces != null) {
        return matchedOperator;
      }
      return findMnoInfoByBankCode(this.repaymentData, bankCode) || matchedOperator;
    },
    formattedAmount() {
      const amount = this.repaymentData?.paymentData?.amount;
      if (amount == null) {
        return amount;
      }
      return formatDecimalByPlaces(
        String(amount),
        this.currentBankInfo?.decimalPlaces
      );
    },
  },
  created() {
    this.repaymentData = this.pageData;
    console.log("this.repaymentData", this.repaymentData);
    this.updateCode();
    this.setLanguageBasedOnCountry(this.countryInfo?.enName);
    this.initOperatorList();

    if (this.repaymentData?.paymentData?.checkoutStatus && (this.repaymentData?.paymentData?.checkoutStatus == "INIT" || this.repaymentData?.paymentData?.checkoutStatus == "OPENED")) {

      // 优先从 customerAccountNumber 读取，如果没有则从 paymentAccountNumber 读取
      const accountNumber = this.repaymentData.paymentData.customerAccountNumber || this.repaymentData.paymentData.paymentAccountNumber;
      const bankCode = this.repaymentData?.paymentData?.bankCode;

      // 如果接口返回了账号和银行代码，自动填充
      if (accountNumber && bankCode) {
        // 处理账号
        if (this.checkPhone(accountNumber)) {
          this.paymentAccount = accountNumber;
          let paymentAccountNumber = this.zeroFill(accountNumber);
          paymentAccountNumber = paymentAccountNumber.trim();
          this.paymentAccountNumber = paymentAccountNumber;
        }

        // 处理银行代码
        const value = this.operatorOptions.find(
          (v) => String(v.value) == String(bankCode)
        );
        if (value) {
          this.operator = value.text;
          this.operatorValue = value.value;
        }

        // 如果 extraParams 不包含这些参数，说明需要自动提交
        if (!this.repaymentData.extraParams.includes("customerAccountNumber") && !this.repaymentData.extraParams.includes("customerBankCode")) {
          // 自动提交
          this.submitTrxNo();
        } else {
          // 需要用户确认，显示弹窗
          this.paymentAccountShow = true;
        }
      } else if (this.repaymentData.extraParams.includes("customerAccountNumber") || this.repaymentData.extraParams.includes("customerBankCode")) {
          // 如果 extraParams 包含这些参数，但接口没有返回完整数据，显示弹窗让用户输入
          if (
            accountNumber &&
            this.checkPhone(accountNumber)
          ) {
            this.paymentAccount = accountNumber;
          }
          if (bankCode) {
            const value = this.operatorOptions.find(
              (v) => String(v.value) == String(bankCode)
            );
            if (value) {
              this.operator = value.text;
              this.operatorValue = value.value;
            }
          }
          this.paymentAccountShow = true;
      } else {
        this.submitTrxNo();
      }
    } else {
      // checkoutStatus >= THIRD_RESPONSE_SUCCESS: precreate 已完成，emit paymentInitiated 直接开始 polling
      this.$emit("paymentInitiated");
    }

    // this.paymentAccountShow = true;
    this.isPending = true;
    this.init();
  },
  methods: {
    setLanguageBasedOnCountry(countryCode = "EN") {
      setLanguageByCountry(countryCode, this);
    },
    realFocus(str) {
      if (str == "operator") {
        this.operatorPopup = true;
      }
    },
    operatorChange(value) {
      this.operator = value.text;
      this.operatorValue = value.value;
      this.operatorPopup = false;
    },
    async paymentAccountSubmit() {
      // console.log("this.operatorValue", this.operatorValue)
      if (this.operatorOptions.length && !this.operatorValue) {
        this.$toast("Please select the operator");
        return;
      }
      if (!this.paymentAccount) {
        this.$toast(this.$t("text_please_enter_your_actual_payment_account"));
        return;
      }

      let paymentAccountNumber = this.zeroFill(this.paymentAccount);
      if (!this.checkPhone(paymentAccountNumber)) {
        this.$toast("The format of the mobile phone number is incorrect");
        return;
      }
      //   if(paymentAccountNumber.startsWith("0")){
      //     paymentAccountNumber = paymentAccountNumber.substring(1);
      //   }
      paymentAccountNumber = paymentAccountNumber.trim();
      this.paymentAccountNumber = paymentAccountNumber;

      // this.debounce(this.submitTrxNo, 1000)();
      this.submitTrxNo();
    },
    async submitTrxNo() {
      // let res = await this.$http.checkoutTransactionsInitialize({
      //   paymentAccountNumber: this.paymentAccountNumber,
      //   platformReference: this.$route.params.platformReference,
      //   bankCode: this.operatorValue
      // });
      // let res = await this.$http.phonePaymentInitialize({
      //   paymentAccountNumber: this.paymentAccountNumber,
      //   platformReference: this.$route.params.platformReference,
      //   bankCode: this.operatorValue
      // });
      // if (res.code == "200") {
      //   this.paymentAccountShow = false;
      //   this.confirmRepayment();
      //   this.$emit("refreshData")
      // }
      // console.log(res)

      this.$http
        .v1SdkSysInitialize({
          paymentAccountNumber: this.paymentAccountNumber,
          platformReference: this.$route.params.platformReference,
          customerBankCode: this.operatorValue || undefined,
        })
        .then(() => {
          // precreate 成功，通知父组件启动全局后台轮询
          this.$emit("paymentInitiated");
        })
        .catch((err) => {
          void err;
        });

      this.paymentAccountShow = false;
      this.$emit("refreshData");
    },
    zeroFill(value) {
      return zeroFillPaymentPhone(value, this.countryInfo);
    },
    checkPhone(value) {
      console.log("/^\\d+$/.test(value)", /^\d+$/.test(value));
      console.log(value.length, value[0], value.length == 10, value[0] == 0);
      return checkPaymentPhone(value, this.countryInfo);
    },
    futureDay() {
      clearTimeout(this.setTimeoutID);
      // console.log("futureDay", this.pageData.remainTime)
      const msec = this.pageData.remainTime;
      this.pageData.remainTime -= 1000;
      let day = parseInt(msec / 1000 / 60 / 60 / 24);
      let hr = parseInt((msec / 1000 / 60 / 60) % 24) + day * 24;
      let min = parseInt((msec / 1000 / 60) % 60);
      let sec = parseInt((msec / 1000) % 60);
      // console.log(hr, min, sec)
      hr > 99 ? (hr = 99) : hr;
      if (Object.is(hr, NaN) || Object.is(min, NaN) || Object.is(sec, NaN)) {
        hr = 0;
        min = 0;
        sec = 0;
      }
      hr = hr < 0 ? 0 : hr;
      min = min < 0 ? 0 : min;
      sec = sec < 0 ? 0 : sec;
      // this.day = day
      this.hr = hr > 9 ? hr : "0" + hr;
      this.min = min > 9 ? min : "0" + min;
      this.sec = sec > 9 ? sec : "0" + sec;

      // this.repaymentData.day = this.day;
      this.repaymentData.hr = this.hr;
      this.repaymentData.min = this.min;
      this.repaymentData.sec = this.sec;
      this.setTimeoutID = setTimeout(() => {
        this.futureDay();
      }, 1000);

      if (!this.pageData.expirationTime) {
        return;
      }
      if (hr == 0 && min == 0 && sec == 0) {
        clearTimeout(this.setTimeoutID);
        this.$emit("expired");
      }
    },
    back() {
      // try {
      //   window["FlutterClose"].postMessage("hello");
      // } catch (error) {
      //   window.android.close();
      // }
      window.opener = null;
      window.open("", "_self");
      window.close();
    },
    onCopy(str) {
      let url = str;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$toast(this.$t("text_successful_replication"));
      oInput.remove();
    },
    async init() {
      this.futureDay();
    },
    // 与 DisplayLogic / JumpLogic 一致：从 checkout 接口返回的 mnoInfos 构建运营商列表
    initOperatorListFromMnoInfos() {
      if (this.repaymentData?.configData?.checkoutConfigInfoVOList?.mnoInfos?.length) {
        this.repaymentData.configData.checkoutConfigInfoVOList.mnoInfos.forEach((v) => {
          this.operatorOptions.push({
            text: v.bankInfoVO.bankName,
            value: v.bankInfoVO.bankCode,
            decimalPlaces: v.decimalPlaces,
          });
        });
        if (this.operatorOptions.length === 1) {
          this.operator = this.operatorOptions[0].text;
          this.operatorValue = this.operatorOptions[0].value;
        } else if (this.repaymentData?.paymentData?.bankCode) {
          const bankCode = this.repaymentData.paymentData.bankCode;
          const matchedOperator = this.operatorOptions.find(
            (v) => String(v.value) === String(bankCode)
          );
          if (matchedOperator) {
            this.operator = matchedOperator.text;
            this.operatorValue = matchedOperator.value;
          }
        }
      }
    },
    initOperatorList() {
      this.operatorOptions = [];
      this.operator = "";
      this.operatorValue = "";
      // AO 不需要选择运营商
      if (this.countryInfo?.enName === "AO") {
        return;
      }
      if (this.countryInfo?.enName === "GH") {
        this.operatorOptions = [
          { text: "MTN", value: "GH0001" },
          { text: "Telecel", value: "GH0002" },
          { text: "AirtelTigo", value: "GH0036" },
        ];
      } else if (this.countryInfo?.enName === "CM") {
        this.operatorOptions = [
          { text: "MTN", value: "CM0001" },
          { text: "ORANGE", value: "CM0002" },
        ];
      } else if (this.countryInfo?.enName === "BD") {
        this.operatorOptions = [
          { text: "bKash", value: "BD0001" },
          { text: "Nagad", value: "BD0002" },
        ];
      } else {
        this.initOperatorListFromMnoInfos();
      }
    },
    updateCode() {
      applyCountryCurrencyCode(this.repaymentData);
    },
  },
};
</script>

<style lang="scss" scoped>
.repayment {
  height: 100vh;
  padding-top: 40px;
  background-color: #f5f5f5;

  .repayment_pending {
    margin-top: 50px;

    .repayment_pending_text {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #555555;
      text-align: center;
    }

    .repayment_pending_tips {
      margin-top: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #cc8f4e;
      line-height: 20px;
      text-align: center;
      padding: 0 30px;

      span {
        color: #ffaf00;
      }
    }

    .repayment_pending_img_box {
      transform: translateY(-65px);
      display: flex;
      justify-content: center;

      .repayment_pending_img {
        width: 300px;
        height: 300px;
      }
    }

    .repayment_pending_desc {
      transform: translateY(-140px);
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #948f8a;
      line-height: 20px;

      text-align: center;
    }

    .repayment_pending_over {
      transform: translateY(-110px);
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #948f8a;

      line-height: 20px;
      text-align: center;

      span {
        color: #ff2828;
      }
    }
  }

  .repayment_over {
    width: 100%;

    .repayment_over_img_box {
      margin-top: 50px;
      display: flex;
      align-items: center;
      justify-content: center;

      .repayment_over_img {
        width: 50px;
        height: 50px;
        margin: 0 auto;
      }
    }

    .repayment_over_text {
      margin-top: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #029b00;
      text-align: center;
    }

    .repayment_over_btn {
      cursor: pointer;
      position: relative;
      margin: 0 auto;
      margin-top: 30px;
      width: calc(100% - 40px);
      height: 45px;
      background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
      border-radius: 8px;

      font-size: 15px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #996a30;

      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.moblie_pay_payment_account_popup {
  .moblie_pay_payment_account_popup_main {
    width: 305px;
    background: #ffffff;
    border-radius: 15px;
    overflow: hidden;

    .moblie_pay_payment_account_popup_main_title {
      padding-top: 20px;
      margin-left: 20px;
      margin-bottom: 10px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #524535;

      display: flex;
      align-items: center;
      justify-content: flex-start;

      .moblie_pay_payment_account_popup_main_title_img {
        width: 18px;
        height: 18px;
        margin-right: 8px;
      }
    }

    .moblie_pay_payment_account_popup_main_desc {
      margin-left: 20px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #7f7870;
      line-height: 17px;
    }

    .moblie_pay_payment_account_popup_main_detail_title {
      padding-top: 30px;
      margin-left: 20px;
      margin-bottom: 20px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #524535;
    }

    .moblie_pay_payment_account_popup_main_collect_box {
      margin-top: 20px;
      background: rgba(122, 122, 122, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 30px 12px;
      box-sizing: border-box;

      .moblie_pay_payment_account_popup_main_collect_num {
        width: 100%;
        text-align: left;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #7f7870;
      }

      .moblie_pay_payment_account_popup_main_collect_total {
        margin-top: 20px;
        width: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 13px;
        color: #776a5a;

        span {
          color: #DC811D;
          margin-left: 6px;
        }

        .moblie_pay_payment_account_popup_main_collect_total_amount {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
        }

        .moblie_pay_payment_account_popup_main_collect_total_detail {
          cursor: pointer;
          padding: 3px 10px;
          box-sizing: border-box;
          background: rgba(51, 51, 51, 0.12);
          border-radius: 15px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 11px;
          color: #555555;
          margin-left: 8px;
        }

        .moblie_pay_payment_account_popup_main_collect_total_edit {
          cursor: pointer;
          padding: 6px 10px;
          box-sizing: border-box;
          background: rgba(51, 51, 51, 0.12);
          border-radius: 15px;
          margin-left: 8px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 11px;
          color: #555555;

          display: flex;
          align-items: center;
          justify-content: center;

          .moblie_pay_payment_account_popup_main_collect_total_edit_img {
            width: 11px;
            height: 11px;
            margin-right: 2px;
          }
        }
      }
    }

    .moblie_pay_payment_account_popup_main_collect_confirm_box {
      background: rgba(122, 122, 122, 0.1);
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding: 15px 30px;
      box-sizing: border-box;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #7f7870;
      line-height: 17px;

      span {
        color: #DC811D;
        margin: 0 6px;
      }
    }

    .moblie_pay_payment_account_popup_main_cur_account {
      margin-left: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #7f7870;

      span {
        color: #DC811D;
        margin-left: 3px;
      }
    }

    .moblie_pay_payment_account_popup_main_wait_amount {
      margin-top: 15px;
      margin-left: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #776a5a;

      span {
        color: #DC811D;
        margin-left: 3px;
      }

      .moblie_pay_payment_account_popup_main_wait_amount_num {
        font-size: 16px;
      }
    }

    .moblie_pay_container_step_account {
      margin: 0 20px;
      margin-top: 20px;
      display: flex;
      align-items: center;

      .moblie_pay_container_step_account_input_box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 8px;
        border: 1px solid #aaaaaa;
        padding: 0 6px;
        box-sizing: border-box;

        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        outline: none;

        ::v-deep .van-field__right-icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .moblie_pay_container_step_account_input_box_right_img {
          width: 20px;
          height: 20px;
        }
      }

      .moblie_pay_container_step_account_select_box {
        padding: 0 20px;
        box-sizing: border-box;
        height: 40px;
      }

      .moblie_pay_container_step_233 {
        width: 40px;
        color: #DC811D;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
      }

      .moblie_pay_container_step_account_input {
        width: 100%;

        height: 40px;
        border: none;
        //padding-left: 10px;
        box-sizing: border-box;

        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        outline: none;
        //margin-right: 20px;

        &:focus {
          //border: 1px solid #DC811D;
        }

        &::placeholder {
          color: #bbbbbb;
        }
      }
    }

    .moblie_pay_container_step_tips {
      margin-top: 2px;
      font-size: 12px;
      text-align: center;
      span {
        color: red;
      }
    }

    .moblie_pay_container_step_pay_account {
      margin-top: 15px;
      padding: 10px 0;
      background: rgba(218, 91, 91, 0.1);
      padding-left: 20px;
      box-sizing: border-box;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;

      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 11px;
      color: #da5b5b;
      line-height: 16px;

      .moblie_pay_container_step_pay_account_img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }
    }

    .moblie_pay_container_step_account_submit {
      margin: 0 auto;
      margin-top: 15px;
      position: relative;
      width: 120px;
      height: 40px;
      background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
      border-radius: 8px;

      font-size: 15px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #996a30;

      display: flex;
      align-items: center;
      justify-content: center;

      .moblie_pay_container_step_account_submit_text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
      }

      .moblie_pay_container_step_account_submit_img {
        position: absolute;
        top: 50%;
        left: 60%;
        transform: translate(50%, -50%);
        width: 24px;
        height: 13px;
        z-index: 1;
      }
    }

    .moblie_pay_payment_account_popup_main_confirm_box {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .moblie_pay_payment_account_popup_close_box {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .moblie_pay_payment_account_popup_close {
      cursor: pointer;
      width: 30px;
      height: 30px;
    }
  }
}
</style>
